/**
 * SGKC029A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TankaInfoDto {

    /**
     * 料金表種別
     */
    feetableClsfy?: string;
    /**
     * 使用量下限
     */
    empamtLowerlimit?: number;
    /**
     * 使用量上限
     */
    empamtUpperlimit?: number;
    /**
     * 基本料金
     */
    basicCharge?: number;
    /**
     * 基準単位料金
     */
    standardsunitfee?: number;
}

